import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface Props {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    userName: string;
}

export default function ConfirmAllEventsDialog(props: Props) {
    const handleConfirm = () => {
        props.onConfirm();
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={props.onClose}>
            <DialogTitle>Grant Access to All Events?</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Grant access to ALL events for {props.userName}? This will allow them to view all current and future events.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.onClose} autoFocus>
                    Cancel
                </Button>
                <Button onClick={handleConfirm} color="primary">
                    Grant Access
                </Button>
            </DialogActions>
        </Dialog>
    );
}
